import React from "react";
import { Typography, Layout } from "antd";
import HeaderBar from "../components/common/CommonHeader";
import FooterBar from "../components/common/CommonFooter";

const { Content } = Layout;
const { Title, Paragraph, Text } = Typography;

const PrivacyPolicy = () => {
  return (
    <Layout style={{ background: "#fff" }}>
      <HeaderBar bgColor="#DDC7BB" />

      <Content
        style={{
          padding: "60px 80px",
          maxWidth: 1000,
          margin: "0 auto",
        }}
      >
        {/* Page Heading */}
        <div
          style={{
            height: "50px",
            width: "260px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "20px auto",
            borderRadius: "20px",
            padding: "20px",
          }}
        >
          <Title level={2} style={{ margin: 0 }}>
            Privacy Policy
          </Title>
        </div>

        <Typography>
          <Paragraph data-aos="fade-up">
            <Text strong>Effective Date:</Text> October 23, 2025
          </Paragraph>

          <Paragraph data-aos="fade-up">
            This Privacy Policy explains how <Text strong>Not in the Market</Text> (“we,” “our,” or “us”)
            collects, uses, and protects your personal information when you use our website and
            services.
          </Paragraph>

          <Title level={4} data-aos="fade-up">
            1. Who We Are
          </Title>
          <Paragraph data-aos="fade-up">
            Not in the Market is a Dubai-registered real estate platform that operates internationally.
            We connect property buyers and sellers through verified listings, direct workflows, and
            transparent data practices.
          </Paragraph>

          <Title level={4} data-aos="fade-up">
            2. Who This Policy Applies To
          </Title>
          <Paragraph data-aos="fade-up">
            This policy applies to:
            <ul>
              <li>Property buyers browsing or inquiring about listings</li>
              <li>Property owners submitting listings through our platform</li>
            </ul>
            We do not work with agents or third-party brokers.
          </Paragraph>

          <Title level={4} data-aos="fade-up">
            3. What Information We Collect
          </Title>
          <Paragraph data-aos="fade-up">
            We collect the following types of data:
          </Paragraph>
          <ul data-aos="fade-up">
            <li>
              <Text strong>Personal Information (submitted by users):</Text>
              <ul>
                <li>Name</li>
                <li>Email address</li>
                <li>Government-issued ID</li>
                <li>Property ownership documents</li>
              </ul>
            </li>
            <li>
              <Text strong>Technical Information (automatically collected):</Text>
              <ul>
                <li>IP address</li>
                <li>Browser type</li>
                <li>Device information</li>
                <li>Usage data (e.g. page views, search filters)</li>
              </ul>
            </li>
          </ul>

          <Title level={4} data-aos="fade-up">
            4. Why We Collect Your Data
          </Title>
          <Paragraph data-aos="fade-up">
            We use your data for:
            <ul>
              <li>Verifying property ownership and listing eligibility</li>
              <li>Providing user support and follow-up</li>
              <li>Analyzing platform performance and user behavior</li>
            </ul>
            We do not use your data for marketing, advertising, or profiling.
          </Paragraph>

          <Title level={4} data-aos="fade-up">
            5. Cookies and Tracking
          </Title>
          <Paragraph data-aos="fade-up">
            We use cookies to:
            <ul>
              <li>Enable secure login and navigation</li>
              <li>Remember user preferences</li>
              <li>Analyze site performance</li>
              <li>Support cross-site tracking and remarketing</li>
            </ul>
            For more details, contact us at{" "}
            <Text strong>privacy@notinthemarket.com</Text> or see our{" "}
            <Text strong>Cookie Policy</Text>.
          </Paragraph>

          <Title level={4} data-aos="fade-up">
            6. Data Sharing
          </Title>
          <Paragraph data-aos="fade-up">
            We do not share your personal data with third parties. However, embedded third-party
            services (e.g. maps, videos, chat tools) may collect data independently.
          </Paragraph>

          <Title level={4} data-aos="fade-up">
            7. Data Retention
          </Title>
          <Paragraph data-aos="fade-up">
            We retain user data for one year from the date of submission or last activity. If you
            wish to close your account, please contact us manually via email.
          </Paragraph>

          <Title level={4} data-aos="fade-up">
            8. Data Security
          </Title>
          <Paragraph data-aos="fade-up">
            We protect your data using encryption, secure servers, and access controls. Only
            authorized team members can access sensitive information.
          </Paragraph>

          <Title level={4} data-aos="fade-up">
            9. Your Rights
          </Title>
          <Paragraph data-aos="fade-up">
            If you are located in the European Union or other regions with privacy laws, you have
            the right to:
            <ul>
              <li>Access your personal data</li>
              <li>Request correction or deletion</li>
              <li>Withdraw consent (where applicable)</li>
            </ul>
            To exercise these rights or ask questions, contact us at{" "}
            <Text strong>privacy@notinthemarket.com</Text>.
          </Paragraph>
        </Typography>
      </Content>

      <FooterBar />
    </Layout>
  );
};

export default PrivacyPolicy;
